export function middleCoord(coord1, coord2) {
  if (coord1 === null || coord1 === undefined || coord2 === null || coord2 === undefined) {
    return null;
  }

  return (coord1 + coord2) / 2;
}

export function middlePoint(point1, point2) {
  console.log(point1, point2);
  return {
    lat: middleCoord(point1?.latitude || 0, point2?.latitude || 0),
    lng: middleCoord(point1?.longitude || 0, point2?.longitude || 0),
  };
}
